import { Link } from 'react-router-dom'
import { ClientHeader } from '../components/layout/ClientHeader'
import { ClientFooter } from '../components/layout/ClientFooter'

export function Homepage() {
  return (
    <div className="homepage">
      <ClientHeader />

      <main className="homepage-main">
        <section className="hero" aria-labelledby="hero-title">
          <div className="container">
            <div className="hero-grid">
              <div className="hero-content">
                <div className="hero-badges" aria-label="Keunggulan">
                  <span className="hero-badge">Simple</span>
                  <span className="hero-divider" aria-hidden="true">•</span>
                  <span className="hero-badge">Fast</span>
                  <span className="hero-divider" aria-hidden="true">•</span>
                  <span className="hero-badge">Mobile Friendly</span>
                </div>

                <h1 id="hero-title" className="hero-title">
                  Belanja jadi lebih mudah.
                </h1>

                <p className="hero-description">
                  Platform pemesanan grosir modern untuk warung dan toko kelontong.
                  Pilih produk, tentukan jumlah, dan pesanan siap dikirim — semua dari genggaman tangan.
                </p>

                <Link to="/order" className="btn btn-primary btn-lg hero-cta">
                  Mulai Belanja
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </Link>

                <p className="hero-note">
                  Tidak perlu akun. Cukup masukkan nama outlet dan mulai pesan.
                </p>
              </div>

              <aside className="hero-summary" aria-label="Ringkasan cara belanja">
                <div className="summary-card">
                  <h2 className="summary-title">Cara Belanja</h2>
                  <ol className="summary-steps">
                    <li className="summary-step">
                      <span className="summary-step-number">1</span>
                      <div className="summary-step-content">
                        <span className="summary-step-title">Masukkan Nama Outlet</span>
                        <span className="summary-step-desc">Identifikasi toko Anda</span>
                      </div>
                    </li>
                    <li className="summary-step">
                      <span className="summary-step-number">2</span>
                      <div className="summary-step-content">
                        <span className="summary-step-title">Pilih Produk & Jenis</span>
                        <span className="summary-step-desc">Satuan / Dus / Renteng</span>
                      </div>
                    </li>
                    <li className="summary-step">
                      <span className="summary-step-number">3</span>
                      <div className="summary-step-content">
                        <span className="summary-step-title">Atur Jumlah</span>
                        <span className="summary-step-desc">Tambah ke keranjang</span>
                      </div>
                    </li>
                    <li className="summary-step">
                      <span className="summary-step-number">4</span>
                      <div className="summary-step-content">
                        <span className="summary-step-title">Konfirmasi Pesanan</span>
                        <span className="summary-step-desc">Struk otomatis tercetak</span>
                      </div>
                    </li>
                  </ol>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="features" aria-labelledby="features-title">
          <div className="container">
            <header className="features-header">
              <h2 id="features-title" className="features-title">Fitur Unggulan</h2>
              <p className="features-subtitle">Dirancang untuk mempermudah proses belanja grosir harian</p>
            </header>

            <div className="features-grid">
              <article className="feature-card">
                <div className="feature-icon" aria-hidden="true">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <h3 className="feature-title">Cari Barang Cepat</h3>
                <p className="feature-desc">Daftar produk lengkap dengan harga PCS, Pack, dan Half Pack. Temukan barang yang dibutuhkan dalam hitungan detik.</p>
              </article>

              <article className="feature-card">
                <div className="feature-icon" aria-hidden="true">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                  </svg>
                </div>
                <h3 className="feature-title">Keranjang Floating</h3>
                <p className="feature-desc">Keranjang belanja melayang yang selalu aksesibel. Lihat, edit, dan kelola item tanpa meninggalkan halaman produk.</p>
              </article>

              <article className="feature-card">
                <div className="feature-icon" aria-hidden="true">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="feature-title">Responsif & Mobile-First</h3>
                <p className="feature-desc">Tampilan optimal di HP, tablet, dan desktop. Belanja kapan saja, di mana saja, tanpa ribet zoom atau scroll horizontal.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="cta-section" aria-labelledby="cta-title">
          <div className="container">
            <div className="cta-card">
              <h2 id="cta-title" className="cta-title">Siap Memulai?</h2>
              <p className="cta-desc">Buka halaman belanja, masukkan nama outlet, dan buat pesanan pertama Anda hari ini.</p>
              <Link to="/order" className="btn btn-primary btn-lg cta-btn">
                Buka Halaman Belanja
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <ClientFooter />
    </div>
  )
}